import * as React from 'react';
import * as _ from 'lodash';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { fetchPostsWP } from '../actions/posts';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import ListPost from './component/ListPost';
import NewLetter from './component/NewLetter';
import LikePage from './component/LikePage';

class DefaultCategory extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			page: 5,
			loading: true
		}
	}

	componentDidMount() {
		this.props.fetchPostsWP({
			number: 100,
			orderby: 'date',
			order: 'desc'
		});
		document.title = this.props.t('news');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.postsWP.loading == false) {
			this.setState({
				loading: false
			})
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.postsWP.loading) {
			return false;
		} else {
			return true;
		}
	}

	changePage = () => {
		this.setState((previousState) => {
			return {page: previousState.page + 5};
		});
	};

	render() {

		const { t, postsWP } = this.props;

		const { page } = this.state;

		var pagedItems = _.drop(postsWP.data, 0).slice(0, page);

		var data_post = pagedItems.map((item) => {
			var slug = 'uncategorized';
			if(item.terms.length > 0) {
				slug = item.terms[0]['slug']
			}
			return (
				<ListPost key={item.post_id} category_slug={slug} item={item}/>
			);
		});

		return (
			<div className="news listNews ">
				<div className="container">
					<div className="row">
						<div className="col-md-12 col-lg-8 columnLeft">
							{data_post}
						</div>
						<div className="col-sm-4 columnRight ">
							<div className="sidebarNews">
								<LikePage/>
								<NewLetter/>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-sm-12">
							{page >= postsWP.data.length ? '' :
							<div className="load-more-wrapper">
								<div onClick={this.changePage} className="btn btn-block  click-load">
									<span>{t('view_more')}</span>
								</div>
							</div>}
						</div>
					</div>
				</div>
				{this.state.loading ? <div className="loadingPage active"> <img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>
		);
	}
}

export default connect(mapStateToProps([
	'postsWP'
]), mapDispatchToProps({
	 fetchPostsWP
}))(translate('translations')(DefaultCategory));



// WEBPACK FOOTER //
// ./src/containers/DefaultCategory.tsx